import * as React from "react";
import type { SVGProps } from "react";
const SvgPrivacyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M3.494 4C2.674 4 2 4.678 2 5.502v5.506c0 .823.675 1.501 1.494 1.501H6.48c0 .93.646 1.713 1.506 1.934v5.55c0 .278-.222.501-.498.501H2v1.001h5.489c.82 0 1.494-.678 1.494-1.501v-5.558a2.004 2.004 0 0 0 1.482-1.927h8.963c.819 0 1.494-.678 1.494-1.501v-.725l3.592 1.644.021.008c.639.258 1.366-.237 1.366-.928V5.502c0-.692-.727-1.186-1.366-.93l-.021.01-3.592 1.643v-.723c0-.824-.675-1.502-1.494-1.502zm0 1.001h15.934c.281 0 .498.218.498.5v5.507c0 .282-.217.5-.498.5H3.494a.49.49 0 0 1-.498-.5V5.502c0-.283.216-.5.498-.5m21.41.502v5.503l-3.982-1.823V7.325zM7.478 12.509H9.47a.99.99 0 0 1-.996 1.001.99.99 0 0 1-.996-1M18.93 16.99c-3.785 0-6.772 4.055-6.872 4.205l-.198.3.198.3c.1.15 3.087 4.205 6.872 4.205s6.772-4.055 6.872-4.205l.198-.3-.198-.3c-.1-.15-3.088-4.205-6.872-4.205m0 1.001c2.738 0 5.128 2.603 5.825 3.504-.697.901-3.087 3.504-5.825 3.504s-5.079-2.603-5.826-3.504c.697-.9 3.087-3.504 5.826-3.504m0 .5c-1.643 0-2.988 1.352-2.988 3.004s1.345 3.003 2.988 3.003 2.987-1.351 2.987-3.003-1.344-3.003-2.987-3.003m0 1.002a2.003 2.003 0 0 1 0 4.004 2.003 2.003 0 0 1 0-4.004m0 1.001a1.001 1.001 0 0 0 0 2.002 1.001 1.001 0 0 0 0-2.002"
    />
  </svg>
);
export default SvgPrivacyIcon;
